import { render, staticRenderFns } from "./AdminQuotation.vue?vue&type=template&id=55d470c2&scoped=true&"
import script from "./AdminQuotation.vue?vue&type=script&lang=js&"
export * from "./AdminQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d470c2",
  null
  
)

export default component.exports